// client/src/components/event/EventHub.jsx
//
// Event picker for the Hub. Lists the tenant's events; each links to the
// per-event dashboard at /:tenant/:eventId/hub (EventHubDashboard.jsx).

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

function fmtDate(d) {
  if (!d) return "";
  try { return new Date(d).toLocaleDateString(undefined, { dateStyle: "medium" }); }
  catch { return ""; }
}

const EventHub = ({ tenantId, tenant }) => {
  const tid = tenantId || tenant;
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${baseUrl}/api/events/${tid}/events`);
        setEvents(data.data || data.events || []);
      } catch (err) {
        setError(err?.response?.data?.message || "Failed to load events");
      } finally {
        setLoading(false);
      }
    })();
  }, [tid]);

  return (
    <div className="max-w-2xl mx-auto p-4">
      <h1 className="text-2xl font-semibold mb-1">Event Hub</h1>
      <p className="opacity-70 text-sm mb-4">Pick an event to see tasks, tickets, check-in, budget and vendors in one place.</p>

      {loading && <div className="text-sm opacity-70">Loading…</div>}
      {error && <div className="text-sm text-red-600">{error}</div>}

      <div className="space-y-2">
        {events.map((e) => (
          <button
            key={e.id}
            onClick={() => navigate(`/${tid}/${e.id}/hub`)}
            className="w-full text-left rounded-lg border border-black/10 dark:border-white/10 p-3 hover:bg-black/5 dark:hover:bg-white/5"
          >
            <div className="font-medium">{e.name}</div>
            <div className="text-xs opacity-60">
              {fmtDate(e.startdate)}{e.enddate ? ` – ${fmtDate(e.enddate)}` : ""}
              {e.ownership === "shared" ? " · shared with you" : ""}
            </div>
          </button>
        ))}
        {!loading && events.length === 0 && (
          <div className="text-sm opacity-60">No events yet.</div>
        )}
      </div>
    </div>
  );
};

export default EventHub;
